import { api } from './client';
import type { Hotel, HotelDocument } from '../types';

export interface ExtractedHotelData {
  name:                  string;
  address?:              string;
  checkIn:               string;
  checkOut:              string;
  bookingRef?:           string;
  aiCreditsLeft:         number;
  premiumAiCreditsLeft:  number;
}

export const hotelsApi = {
  list: (tripId: string) =>
    api.get<Hotel[]>(`/trips/${tripId}/hotels`).then(r => r.data),
  create: (tripId: string, data: Partial<Hotel>) =>
    api.post<Hotel>(`/trips/${tripId}/hotels`, data).then(r => r.data),
  update: (tripId: string, hotelId: string, data: Partial<Hotel>) =>
    api.patch<Hotel>(`/trips/${tripId}/hotels/${hotelId}`, data).then(r => r.data),
  delete: (tripId: string, hotelId: string) =>
    api.delete(`/trips/${tripId}/hotels/${hotelId}`),
  uploadDocument: (tripId: string, hotelId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<HotelDocument>(
      `/trips/${tripId}/hotels/${hotelId}/documents`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data);
  },
  deleteDocument: (tripId: string, hotelId: string, docId: string) =>
    api.delete(`/trips/${tripId}/hotels/${hotelId}/documents/${docId}`),
  extract: (tripId: string, files: File[]) => {
    const form = new FormData();
    files.forEach(file => form.append('files', file));
    return api.post<ExtractedHotelData>(
      `/trips/${tripId}/hotels/extract`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data);
  },
};
